var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-image',{staticClass:"carrier-image",attrs:{"src":`${_vm.url}/images/carriers/${_vm.carrier}.png?w=500&context=business_panel`,"fit":'contain',"ondragstart":"return false"}},[_c('div',{staticClass:"image-slot",attrs:{"slot":"error"},slot:"error"},[_vm._v(_vm._s(_vm.carrier))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }